document.addEventListener('DOMContentLoaded', () => {
    const videoCarousels = document.querySelectorAll('.js-video-carousel');

    videoCarousels.forEach(carousel => {
        // Initialize Flickity
        let flkty;
        if (typeof Flickity !== 'undefined') {
            flkty = new Flickity(carousel, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                pageDots: false,
                prevNextButtons: true,
                groupCells: false,
                autoPlay: false
            });
        }

        // Play/Pause functionality
        carousel.addEventListener('click', function (e) {
            const slide = e.target.closest('.video-carousel__slide');
            const muteButton = e.target.closest('.video-carousel__mute-button');

            if (muteButton && slide) {
                // Handle mute/unmute click
                const video = slide.querySelector('video');
                if (video) {
                    const isMuting = !video.muted;

                    // If we are unmuting this video, mute ALL other videos first
                    if (!isMuting) {
                        const allVideos = document.querySelectorAll('.video-carousel__video');
                        allVideos.forEach(v => {
                            if (v !== video && !v.muted) {
                                v.muted = true;
                                const otherSlide = v.closest('.video-carousel__slide');
                                if (otherSlide) {
                                    const otherMuteBtn = otherSlide.querySelector('.video-carousel__mute-button');
                                    if (otherMuteBtn) {
                                        const otherMuteIcon = otherMuteBtn.querySelector('.video-carousel__icon-mute');
                                        const otherUnmuteIcon = otherMuteBtn.querySelector('.video-carousel__icon-unmute');
                                        if (otherMuteIcon) otherMuteIcon.style.display = 'flex';
                                        if (otherUnmuteIcon) otherUnmuteIcon.style.display = 'none';
                                    }
                                }
                            }
                        });
                    }

                    video.muted = isMuting;

                    const muteIcon = muteButton.querySelector('.video-carousel__icon-mute');
                    const unmuteIcon = muteButton.querySelector('.video-carousel__icon-unmute');

                    if (video.muted) {
                        if (muteIcon) muteIcon.style.display = 'flex';
                        if (unmuteIcon) unmuteIcon.style.display = 'none';
                    } else {
                        if (muteIcon) muteIcon.style.display = 'none';
                        if (unmuteIcon) unmuteIcon.style.display = 'flex';
                    }
                }
            } else if (slide) {
                // Handle play/pause click
                const video = slide.querySelector('video');
                if (video) {
                    if (video.paused) {
                        video.play();
                        slide.classList.remove('is-paused');
                    } else {
                        video.pause();
                        slide.classList.add('is-paused');
                    }
                }
            }
        });

        // Ensure videos play/pause based on visibility or defaults
        // Default behavior: autoplay is on in HTML, so videos play.
        // We might want to pause videos that are not selected if performance is an issue,
        // but user requested cloning which implies multiple videos visible.
        // Keeping it simple for now as per request: just the button logic.
    });
});
